import React from 'react';
import { Row, Col, Card, Collapse } from 'react-bootstrap';

import { render_marked_finding } from '../utils/HiddenText';

function Strengths({
	analysis_results,
	show_strengths,
	set_show_strengths
}){

	// Strengths section renderer
	const render_strengths_section = ()=> {
		const strengths = analysis_results.strengths.strengths_list;
		if(!strengths){
			return;
		}

		return (
			<Card className="analysis-results-card strengths-card">
				<h3 className="strengths-title" 
					onClick={()=>set_show_strengths(!show_strengths)} 
					style={{cursor:'pointer'}}>
					Strengths {show_strengths ? "▲" : "▼"}
				</h3>
				<p className="strengths-desc">
					This section highlights areas where the page performs well in clarity, structure, and AI-search suitability.
				</p>

				<Collapse in={show_strengths}>
				<div>
				<Row>
					<Col md={4}>
						<div className="strengths-bool-list">
							<div className="strengths-bool-item strengths-bool-true">
								<span className="strengths-bool-icon"></span>
								<span className="strengths-bool-label">Clear strengths identified</span>
							</div>
						</div>
					</Col>

					<Col md={8}>
						<div className="strengths-list">
							{strengths.map((finding, index)=> {
								return (
									<div key={index} className="strengths-text-box">{render_marked_finding(finding, analysis_results)}</div>
								);
							})}
						</div>
					</Col>
				</Row>
				</div>
				</Collapse>
			</Card>
		);
	};

	if(!analysis_results || !analysis_results.strengths){
		return null;
	}

	return render_strengths_section();
}

export default Strengths;
